import HubspotCRUDActions from '../actions/HubspotCRUDActions';
import {
  HubspotAccessToken,
  HubspotOauthToken,
} from '../model/ConnectionModel';
import { HubspotModel } from '../model/HubspotModel';

import { setBusy, setUnBusy } from './common/commonReducers';

type AccountsAction = {
  type: string;
  accounts: HubspotOauthToken[] | HubspotAccessToken[];
  lists: string[];
  account: HubspotOauthToken | HubspotAccessToken;
};

type RevokeAction = {
  type: string;
  id: number | null;
  accounts: HubspotOauthToken[] | HubspotAccessToken[];
  lists: string[];
  account: HubspotOauthToken | HubspotAccessToken;
};

const initialState: HubspotModel = {
  busy: false,
  accounts: [],
  lists: [],
};

export const hubspot = (
  state = initialState,
  action: AccountsAction | RevokeAction,
) => {
  switch (action.type) {
    case HubspotCRUDActions.busyAction:
      return setBusy(state);
    case HubspotCRUDActions.retrieveLists: {
      return {
        ...state,
        lists: action.lists,
        busy: false,
      };
    }
    case HubspotCRUDActions.retrieveOauthUrlAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case HubspotCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: (action as AccountsAction).accounts,
        busy: false,
      };
    }
    case HubspotCRUDActions.retrievedAccessToken: {
      const { accounts } = state;
      const accessTokenIndex = accounts.findIndex(
        accessToken =>
          accessToken.type === action.account.type &&
          accessToken.id === action.account.id,
      );
      let newAccounts;
      if (accessTokenIndex >= 0) {
        newAccounts = Object.assign([], accounts, {
          [accessTokenIndex]: { ...action.account, readOnly: false },
        });
      } else {
        newAccounts = [{ ...action.account, readOnly: false }, ...accounts];
      }
      return {
        ...state,
        busy: false,
        accounts: newAccounts,
      };
    }
    case HubspotCRUDActions.revokeAction: {
      const revokeAction = action as RevokeAction;
      if (revokeAction.id === null) {
        return {
          ...state,
          busy: false,
        };
      }
      return {
        ...state,
        busy: false,
        accounts: state.accounts.filter(acc => acc.id !== revokeAction.id),
      };
    }
    case HubspotCRUDActions.resetStore: {
      return initialState;
    }
    case HubspotCRUDActions.unbusyAction:
      return setUnBusy(state);
    default:
      return state;
  }
};
